module.exports = __webpack_public_path__ + "img/mzs.97da14aa.jpg";